import styled from 'styled-components';

import { Color, ZIndex } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { hexToRgba } from '../../utils';

export const Container: StyledComponent<'div'> = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 50px;
  box-shadow: 0px 0px 4px ${hexToRgba(Color.Black, 0.2)};
  color: ${Color.White};
  margin: 80px auto 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: ${ZIndex.LoadingSpinner};
`;

export const Spinner: StyledComponent<'div'> = styled.div`
  width: 24px;
  height: 24px;
  border: 3px solid ${Color.Error500};
  border-bottom-color: ${Color.Gray200};
  border-radius: 50%;
  display: inline-block;
  animation: rotation 1s linear infinite;

  @keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
  }
`;
